// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__oPbmy","sider":"styles_sider__yE7K5"};